import { combineReducers } from 'redux';

import currentPageNumber from './reducers/currentPageNumber';
import defaultScale from './reducers/defaultScale';
import errorMessage from './reducers/errorMessage';
import lastNavigatePage from './reducers/lastNavigatePage';
import loadingStatus from './reducers/loadingStatus';
import maxScale from './reducers/maxScale';
import minScale from './reducers/minScale';
import pageLeftPositions from './reducers/pageLeftPositions';
import pageViewportSizes from './reducers/pageViewportSizes';
import viewerPinchDisabled from './reducers/pinchZoomDisabled';
import scale from './reducers/scale';
import viewerScale from './reducers/viewerScale';

const pdfReducer = combineReducers({
  currentPageNumber,
  defaultScale,
  errorMessage,
  lastNavigatePage,
  loadingStatus,
  maxScale,
  minScale,
  pageLeftPositions,
  pageViewportSizes,
  scale,
  viewerPinchDisabled,
  viewerScale,
});

export default pdfReducer;

export type PdfState = ReturnType<typeof pdfReducer>;
